import { render, staticRenderFns } from "./_createdInfo.vue?vue&type=template&id=4b7f53cc&scoped=true&"
import script from "./_createdInfo.vue?vue&type=script&lang=js&"
export * from "./_createdInfo.vue?vue&type=script&lang=js&"
import style0 from "./_createdInfo.vue?vue&type=style&index=0&id=4b7f53cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f53cc",
  null
  
)

export default component.exports